module.exports = __webpack_public_path__ + "static/media/modernizer.43c22412.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/modernizer.svg
 ** module id = 228
 ** module chunks = 0
 **/